/* tslint:disable */
/* eslint-disable */
/**
 * MetX Workbench
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime.js';
/**
 *
 */
export class ColormapsApi extends runtime.BaseAPI {
    /**
     * Get Colormaps By User
     */
    async colormapsByUserRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/colormaps/`;
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Colormaps By User
     */
    async colormapsByUser(initOverrides) {
        const response = await this.colormapsByUserRaw(initOverrides);
        return await response.value();
    }
    /**
     * Copy Colormap
     */
    async colormapsCopyRaw(requestParameters, initOverrides) {
        if (requestParameters['colormapId'] == null) {
            throw new runtime.RequiredError('colormapId', 'Required parameter "colormapId" was null or undefined when calling colormapsCopy().');
        }
        const queryParameters = {};
        if (requestParameters['colormapId'] != null) {
            queryParameters['colormap_id'] = requestParameters['colormapId'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/colormaps/copy`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Copy Colormap
     */
    async colormapsCopy(requestParameters, initOverrides) {
        const response = await this.colormapsCopyRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Create Colormap
     */
    async colormapsCreateRaw(requestParameters, initOverrides) {
        if (requestParameters['colormapCreate'] == null) {
            throw new runtime.RequiredError('colormapCreate', 'Required parameter "colormapCreate" was null or undefined when calling colormapsCreate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        let urlPath = `/api/v2/colormaps/`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['colormapCreate'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Create Colormap
     */
    async colormapsCreate(requestParameters, initOverrides) {
        const response = await this.colormapsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Delete Colormap
     */
    async colormapsDeleteRaw(requestParameters, initOverrides) {
        if (requestParameters['colormapId'] == null) {
            throw new runtime.RequiredError('colormapId', 'Required parameter "colormapId" was null or undefined when calling colormapsDelete().');
        }
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/api/v2/colormaps/{colormap_id}`;
        urlPath = urlPath.replace(`{${"colormap_id"}}`, encodeURIComponent(String(requestParameters['colormapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.VoidApiResponse(response);
    }
    /**
     * Delete Colormap
     */
    async colormapsDelete(requestParameters, initOverrides) {
        await this.colormapsDeleteRaw(requestParameters, initOverrides);
    }
    /**
     * Get Colormap
     */
    async colormapsGetRaw(requestParameters, initOverrides) {
        if (requestParameters['colormapId'] == null) {
            throw new runtime.RequiredError('colormapId', 'Required parameter "colormapId" was null or undefined when calling colormapsGet().');
        }
        const queryParameters = {};
        const headerParameters = {};
        let urlPath = `/api/v2/colormaps/{colormap_id}`;
        urlPath = urlPath.replace(`{${"colormap_id"}}`, encodeURIComponent(String(requestParameters['colormapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Get Colormap
     */
    async colormapsGet(requestParameters, initOverrides) {
        const response = await this.colormapsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Update Colormap
     */
    async colormapsUpdateRaw(requestParameters, initOverrides) {
        if (requestParameters['colormapId'] == null) {
            throw new runtime.RequiredError('colormapId', 'Required parameter "colormapId" was null or undefined when calling colormapsUpdate().');
        }
        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError('requestBody', 'Required parameter "requestBody" was null or undefined when calling colormapsUpdate().');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        let urlPath = `/api/v2/colormaps/{colormap_id}`;
        urlPath = urlPath.replace(`{${"colormap_id"}}`, encodeURIComponent(String(requestParameters['colormapId'])));
        const response = await this.request({
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Update Colormap
     */
    async colormapsUpdate(requestParameters, initOverrides) {
        const response = await this.colormapsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * Upload Colormap
     */
    async colormapsUploadRaw(requestParameters, initOverrides) {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError('file', 'Required parameter "file" was null or undefined when calling colormapsUpload().');
        }
        const queryParameters = {};
        if (requestParameters['name'] != null) {
            queryParameters['name'] = requestParameters['name'];
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", []);
        }
        if (this.configuration && this.configuration.apiKey) {
            queryParameters["access_token"] = await this.configuration.apiKey("access_token"); // APIKeyQuery authentication
        }
        const consumes = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);
        let formParams;
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        }
        else {
            formParams = new URLSearchParams();
        }
        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file']);
        }
        let urlPath = `/api/v2/colormaps/upload`;
        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);
        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse(response);
        }
        else {
            return new runtime.TextApiResponse(response);
        }
    }
    /**
     * Upload Colormap
     */
    async colormapsUpload(requestParameters, initOverrides) {
        const response = await this.colormapsUploadRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
